import React from 'react';

const IconLogo = (props) => {
  return <img alt="Logo" src="/static/images/logos/icon_logo.png" {...props} />;
};

export default IconLogo;
